/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OccupationCostForecastOccupationApiModel } from './occupationCostForecastOccupationApiModel';


export interface OccupationCostForecastApiModel { 
    categorizationId: number;
    years: number;
    occupations: Array<OccupationCostForecastOccupationApiModel>;
}

